export default function editorAttachments(state = [], action) {
    if (action.type == 'ATTACHMENT_ADDED') {
        return [
            ...state,
            action.info
        ]
    }

    if (action.type == 'ATTACHMENT_DELETED') {
        var newState = [];
        for (var index in state) {
            if (action.id != state[index].id) newState.push(state[index]);
        }
        return newState;

    }

    if (action.type == 'ATTACHMENTS_CLEAR') {
        return [];
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/editorAttachments.js